import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function ApplicationsOffers({ className }: IconProps) {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_1606)">
        <path
          d="M57.9155 70.9668H25.2871V84.0181H57.9155V70.9668Z"
          fill="#EAEEF9"
        />
        <path
          d="M78.5801 73.4139H5.16623C2.4472 73.4139 0.271973 71.2387 0.271973 68.5197V17.1299C0.271973 14.4109 2.4472 12.2357 5.16623 12.2357H78.5801C81.2992 12.2357 83.4744 14.4109 83.4744 17.1299V68.5197C83.4744 71.2387 81.0273 73.4139 78.5801 73.4139Z"
          fill="#EAEEF9"
        />
        <path
          d="M71.5104 90H11.9636C10.3322 90 8.97266 88.6405 8.97266 87.0091C8.97266 85.3776 10.3322 84.0181 11.9636 84.0181H71.5104C73.1418 84.0181 74.5014 85.3776 74.5014 87.0091C74.2295 88.6405 73.1418 90 71.5104 90Z"
          fill="#EAEEF9"
        />
        <path
          d="M74.7735 67.432H8.70104C7.34152 67.432 6.25391 66.3444 6.25391 64.9849V20.9366C6.25391 19.577 7.34152 18.4894 8.70104 18.4894H74.7735C76.1331 18.4894 77.2207 19.577 77.2207 20.9366V64.9849C77.2207 66.3444 76.1331 67.432 74.7735 67.432Z"
          fill="white"
        />
        <path
          d="M41.6011 47.855C33.9878 47.855 27.4621 53.5649 26.3745 61.1782C26.3745 62.2659 27.1902 63.0816 28.0059 63.0816H54.6525C55.7401 63.0816 56.5558 62.2659 56.2839 61.1782C55.7401 53.5649 49.4863 47.855 41.6011 47.855Z"
          fill="#00C4B3"
        />
        <path
          d="M53.2929 39.6979C53.2929 46.2236 48.1267 51.3897 41.601 51.3897C35.0753 51.3897 29.9092 46.2236 29.9092 39.6979C29.9092 33.1722 35.0753 28.006 41.601 28.006C48.1267 28.006 53.2929 33.1722 53.2929 39.6979Z"
          fill="white"
        />
        <path
          d="M49.7585 39.6979C49.7585 44.3202 45.9519 47.855 41.6014 47.855C36.9791 47.855 33.4443 44.0483 33.4443 39.6979C33.4443 35.0755 36.9791 31.5408 41.6014 31.5408C46.2238 31.5408 49.7585 35.0755 49.7585 39.6979Z"
          fill="#00C4B3"
        />
        <path
          d="M26.6467 41.3293H8.70104C7.34152 41.3293 6.25391 40.2417 6.25391 38.8822V20.9366C6.25391 19.577 7.34152 18.4894 8.70104 18.4894H26.6467C28.0062 18.4894 29.0938 19.577 29.0938 20.9366V38.8822C29.0938 40.2417 28.0062 41.3293 26.6467 41.3293Z"
          fill="#00416B"
        />
        <path
          d="M17.6738 30.7251C13.5953 30.7251 10.6044 33.716 10.0605 37.5227C10.0605 38.0665 10.3325 38.6103 10.8763 38.6103H24.4714C25.0152 38.6103 25.559 38.0665 25.2871 37.5227C24.7433 33.716 21.4805 30.7251 17.6738 30.7251Z"
          fill="#FBFCFE"
        />
        <path
          d="M23.6556 26.6465C23.6556 29.9094 20.9366 32.6284 17.6738 32.6284C14.4109 32.6284 11.6919 29.9094 11.6919 26.6465C11.6919 23.3837 14.4109 20.6647 17.6738 20.6647C20.9366 20.6647 23.6556 23.3837 23.6556 26.6465Z"
          fill="#00416B"
        />
        <path
          d="M21.7523 26.6465C21.7523 28.8218 19.849 30.7251 17.6738 30.7251C15.4985 30.7251 13.5952 28.8218 13.5952 26.6465C13.5952 24.4713 15.4985 22.568 17.6738 22.568C19.849 22.568 21.7523 24.4713 21.7523 26.6465Z"
          fill="#FBFCFE"
        />
        <path
          d="M59.8189 26.1027L54.9247 37.7946C54.6528 38.0665 55.1966 38.6103 55.4685 38.3384L75.0455 26.1027H59.8189Z"
          fill="#DFE3EA"
        />
        <path
          d="M87.5529 29.3656H52.2054C50.8459 29.3656 49.7583 28.2779 49.7583 26.9184V2.44713C49.7583 1.08761 50.8459 0 52.2054 0H87.281C88.6405 0 89.7281 1.08761 89.7281 2.44713V26.9184C90 28.2779 88.9124 29.3656 87.5529 29.3656Z"
          fill="#00416B"
        />
        <path
          d="M81.2992 13.5952C81.2992 10.6042 79.9397 7.61329 77.7645 5.43806C75.5892 3.26284 72.5983 1.90332 69.6074 1.90332C66.6164 1.90332 63.6255 2.99093 61.4503 5.43806C59.275 7.61329 57.9155 10.6042 57.9155 13.5952C57.9155 16.5861 59.0031 19.577 61.4503 21.7523C63.6255 23.9275 66.3445 25.0151 69.6074 25.287H69.8793C72.8702 25.287 75.8612 24.1994 78.0364 21.7523H78.3083L76.405 19.8489L76.1331 20.3927C74.5016 22.0242 72.0545 23.1118 69.6074 23.1118C67.1602 23.1118 64.985 22.2961 63.0817 20.3927C61.4503 18.7613 60.3627 16.3142 60.3627 13.8671C60.3627 11.4199 61.1784 9.24471 63.0817 7.34139C64.7131 5.70997 67.1602 4.62235 69.6074 4.62235C72.0545 4.62235 74.2297 5.70997 76.1331 7.34139C77.4926 8.7009 78.5802 10.6042 78.8521 12.5075H76.9488C76.6769 11.148 76.1331 9.78852 75.0454 8.7009C73.6859 7.34139 71.7826 6.52568 69.8793 6.52568C67.976 6.52568 66.0726 7.34139 64.7131 8.7009C63.3536 10.0604 62.5379 11.9637 62.5379 13.8671C62.5379 15.7704 63.3536 17.6737 64.7131 19.0332C66.0726 20.3927 67.7041 21.2085 69.6074 21.2085C71.5107 21.2085 73.414 20.3927 74.7735 19.0332L75.0454 18.7613L73.414 16.858L73.1421 17.1299C72.3264 17.9456 70.9669 18.4894 69.8793 18.4894C68.5198 18.4894 67.4321 17.9456 66.6164 17.1299C66.0726 16.5861 65.5288 15.7704 65.5288 14.9547H68.7917H70.1512H74.7735H77.2207H81.5711L81.2992 13.5952ZM69.6074 12.5075H68.2479H64.985C65.2569 11.6918 65.5288 11.148 66.0726 10.3323C66.8883 9.51661 68.2479 8.97281 69.3355 8.97281C70.695 8.97281 71.7826 9.51661 72.5983 10.3323C73.1421 10.8761 73.6859 11.6918 73.6859 12.5075H69.6074Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1606">
          <rect width="90" height="90" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
